import { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
// sections
import { AuthContext } from 'src/compass/site/providers';
import { CasPageContent } from 'src/compass/shared/components';
import View404 from './components/View404';

export default function Page404() {
  const { loadingPermission } = useContext(AuthContext);
  return !loadingPermission ? (
    <>
      <Helmet>
        <title> 404 Page Not Found!</title>
      </Helmet>
      <CasPageContent>
        <View404 />
      </CasPageContent>
    </>
  ) : (
    null
  );
}
